import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Heebo:wght@300;400;500;600;700;900&family=Rubik:wght@400;500;600;700&family=Karantina:wght@300;400;700&family=Suez+One&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    direction: rtl;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    transition: background-color ${props => props.theme.transitions.medium};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.title};
    font-weight: ${props => props.theme.fontWeights.bold};
    line-height: 1.2;
  }

  /* Focus styles for accessibility */
  *:focus-visible {
    outline: ${props => props.theme.accessibility.focusOutline};
    outline-offset: 2px;
  }

  /* Skip link for keyboard navigation */
  .skip-link {
    background: ${props => props.theme.accessibility.skipLink.background};
    color: ${props => props.theme.accessibility.skipLink.color};
    padding: 0.5rem 1rem;
    position: absolute;
    transform: translateY(-100%);
    transition: transform 0.3s;

    &:focus {
      transform: translateY(0);
    }
  }

  .high-contrast {
    filter: contrast(150%);
  }

  .dyslexic-font {
    font-family: 'OpenDyslexic', sans-serif;
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

export default GlobalStyle; 